module.exports = __webpack_public_path__ + "static/media/company-address-popup.096f0a76.png";